"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppMobileContext = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const http_requests_1 = require("../http-requests");
const auth_1 = require("../../store/ducks/auth");
const LoadingPage_1 = __importDefault(require("../../modules/consulta/components/LoadingPage"));
const AppContextProvider_1 = require("./AppContextProvider");
const AppMobileContext = (0, react_1.createContext)(undefined);
const AppMobileContextProvider = ({ children, statusRx, guiasPesquisaRx, match, consultaRx, authData, userSessionRx, userLocalRx, }) => {
    const [renderedByApp, setRenderedByApp] = (0, react_1.useState)(false);
    const user = userSessionRx || userLocalRx;
    const [waitProcess, setWaitProcess] = (0, react_1.useState)(true);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { changeLang, lang } = (0, AppContextProvider_1.useAppContext)();
    const [loadedAppLang, setLoadAppLanguage] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    const [lastChangedPageName, setLastChangedPageName] = (0, react_1.useState)();
    //Altera o label do topo do app baseado na pagina
    (0, react_1.useEffect)(() => {
        const { pathname } = location;
        let nextPageName;
        if (!pathname.startsWith('/login')) {
            // eslint-disable-next-line no-nested-ternary
            nextPageName = pathname.startsWith('/meupergamum') ? 'meupergamum' :
                pathname.startsWith('/login') ? 'login' :
                    'catalogo';
            if (lastChangedPageName !== nextPageName) {
                setLastChangedPageName(nextPageName);
                changeAppPageName(nextPageName);
            }
        }
    }, [location.pathname, lastChangedPageName]);
    (0, react_1.useEffect)(() => {
        if (loadedAppLang) {
            changeAppLanguage(lang);
        }
    }, [lang, loadedAppLang]);
    /**
     * Autentica
     */
    (0, react_1.useEffect)(() => {
        const { ReactNativeWebView, appUUID } = window;
        if (ReactNativeWebView && appUUID) {
            http_requests_1.PessoaAPI.authAppUuid(appUUID).then((response) => {
                const { data } = response;
                if (data) {
                    const { user, authPermissions } = data;
                    const credentials = {
                        token: data.credentials.access_token,
                        refresh: data.credentials.refresh_token,
                    };
                    // Seta as novas credenciais na sessao
                    dispatch(auth_1.AuthSession.storeData({
                        credentials,
                        user,
                        authPermissions,
                    }));
                }
                setWaitProcess(false);
            }).catch((error) => {
                sendLogToApp({ error });
                setWaitProcess(false);
            });
        }
        else {
            setWaitProcess(false);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        const { ReactNativeWebView } = window;
        /**
         * Tratar as mensagens do app aqui ...
         * @param event
         */
        const onMessage = (event) => {
            const { data } = event;
            if (data) {
                try {
                    const parsedData = JSON.parse(data);
                    const { id, payload } = parsedData;
                    switch (id) {
                        case 'change_front_language':
                            if (['en', 'pt', 'es'].includes(payload)) {
                                changeLang(payload);
                                setTimeout(() => setLoadAppLanguage(true), 500);
                            }
                            break;
                        case 'log':
                            sendLogToApp(payload);
                            break;
                        default:
                            break;
                    }
                }
                catch (e) { }
            }
        };
        const listenerTarget = /iPhone|iPad|iPod/i.test(navigator.userAgent) ? window : document;
        if (ReactNativeWebView) {
            setRenderedByApp(true);
            listenerTarget.addEventListener('message', onMessage);
        }
        return () => {
            listenerTarget.removeEventListener('message', onMessage);
        };
    }, []);
    function changeAppPageName(pageName) {
        sendMessageToApp({
            id: 'change_page_name',
            payload: pageName
        });
    }
    function changeAppLanguage(language) {
        sendMessageToApp({
            id: 'change_language',
            payload: language
        });
    }
    function sendMessageToApp(data) {
        const { ReactNativeWebView } = window;
        if (ReactNativeWebView) {
            ReactNativeWebView.postMessage(JSON.stringify(data));
        }
    }
    const sendUserDataToApp = (userData) => {
        sendMessageToApp({
            id: 'user_data',
            payload: userData
        });
    };
    const removeUUIDFromApp = () => {
        sendMessageToApp({
            id: 'remove_app_uuid',
        });
    };
    const sendLogToApp = (log) => {
        sendMessageToApp({
            id: 'app_log',
            payload: { log }
        });
    };
    const memoizedData = (0, react_1.useMemo)(() => ({
        sendMessageToApp,
        renderedByApp,
        sendUserDataToApp,
        sendLogToApp,
        removeUUIDFromApp
    }), [renderedByApp, waitProcess]);
    return (react_1.default.createElement(AppMobileContext.Provider, { value: memoizedData }, waitProcess ? react_1.default.createElement(LoadingPage_1.default, null) : children));
};
const useAppMobileContext = () => {
    const context = (0, react_1.useContext)(AppMobileContext);
    if (context === undefined)
        throw new Error('useAppMobileContext must be used within a AppMobileContextProvider');
    return context;
};
exports.useAppMobileContext = useAppMobileContext;
const mapStateToProps = (state) => ({
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    consultaRx: state.pesquisa.consulta,
    authData: state.auth || state.authPersist,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)((0, react_router_dom_1.withRouter)(AppMobileContextProvider));
